<template>
  <div class="hidden lg:block relative w-0 flex-1">
    <img
      class="absolute inset-0 h-full w-full object-cover"
      src="@/assets/images/LogIn.webp"
    />
  </div>
</template>
